import AssessmentIcon from '@material-ui/icons/Assessment'
import AssetStatusCreate from './AssetStatusCreate'
import AssetStatusEdit from './AssetStatusEdit'
import AssetStatusList from './AssetStatusList'

const assetStatuses = (permissions: string[]) => ({
  create: permissions.includes('create:assets') ? AssetStatusCreate : undefined,
  edit: permissions.includes('update:assets') ? AssetStatusEdit : undefined,
  icon: AssessmentIcon,
  list: permissions.includes('read:assets') ? AssetStatusList : undefined,
  name: 'asset-statuses',
})

export default assetStatuses
